<template>
    <BreadCrumb PageTitle="Ajouter un compte prépayé pour une organisation" />
    <AddModalPrepaidAccount/>
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import AddModalPrepaidAccount from "@/components/Compte/AddModalPrepaidAccount.vue";
  
    export default defineComponent({
      name: "AddPrepaidAccountPage",
      components: {
        BreadCrumb,
        AddModalPrepaidAccount,
      },
    });
  </script>